module.exports = __webpack_public_path__ + "img/shiba-body-level1.450ba47e.png";